class StickyHeader extends HTMLElement {
    constructor() {
        super();
        const revertingPoint = Number(this.dataset.revertingPoint);
        this.revertingPoint = Number.isFinite(revertingPoint) ? revertingPoint : null;
        this.isInitiallyTransparent = this.dataset.initiallyTransparent === 'true'
    }

    connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.announcementBar = document.querySelector('.mc-announcement-bar-section:has(.sticky-announcement)');

        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar?.offsetHeight || 0}px`);

        this.footer = document.querySelector('footer');
        document.documentElement.style.setProperty('--footer-height', `${this.footer?.offsetHeight}px`);

        this.headerIsAlwaysSticky = true;
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.isInitiallyTransparent) {
            this.updateTransparency();
        }

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    /**
     * Updates the transparent header state based on scroll position.
     *
     * CSS decides whether this state should visually apply to the current page layout.
     */
    updateTransparency(scrollTop = window.scrollY || document.documentElement.scrollTop) {
        const transparentBackgroundClassName = 'header-background-transparent';

        if (this.revertingPoint !== null) {
            this.classList.toggle(transparentBackgroundClassName, scrollTop <= this.revertingPoint);
        }
    }
    setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--sticky-header-height', this.isInitiallyTransparent ? '0px' : `${this.header.offsetHeight}px`);

    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.isInitiallyTransparent) {
            this.updateTransparency(scrollTop);
        }

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        const isPastHeader = scrollTop > this.headerBounds.bottom;
        const isScrollingDown = scrollTop > this.currentScrollTop;
        const isScrollingUp = scrollTop < this.currentScrollTop;

        if (isPastHeader && (isScrollingDown || isScrollingUp)) {
            this.header.classList.add('scrolled-past-header');

            if (isScrollingDown) {
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (this.preventReveal) {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            } else {
                requestAnimationFrame(this.reveal.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);